// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDBN-S27rvRu8FOMCRI7Z_WiMcb2n7nEIY",
  authDomain: "argos-laptop-garage-5b828.firebaseapp.com",
  projectId: "argos-laptop-garage-5b828",
  storageBucket: "argos-laptop-garage-5b828.appspot.com",
  messagingSenderId: "874415318048",
  appId: "1:874415318048:web:4e0b33a71b7d4946be4845"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;